<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       [attr.title]="minimise ? 'Expand' : 'Minimize'"
       role="button"
       tabindex="0"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"
       (keydown.enter)="minimise=!minimise"
       (keydown.space)="minimise=!minimise; $event.preventDefault()"></i>
    <i class="fa fa-times"
       title="Close"
       role="button"
       tabindex="0"
       style="cursor: pointer;"
       (click)="cancel()"
       (keydown.enter)="cancel()"
       (keydown.space)="cancel(); $event.preventDefault()"></i>
  </div>
</div>

<div class="modal-body content-body" [hidden]="minimise">
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @if (!showFormLoader) {
<div>
    <form name="entityUpdateForm">
      <div class="panel panel-default" style="margin-top:12px">
        <div class="panel-body">
          <div class="form-group-row">
            <div class="form-label-col">
              <label>Tier:</label>
            </div>
            <div class="form-value-col">
              <gtw-custom-select-local-system
                      [options]="tier_data"
                      displayKey="LABEL"
                      placeholder="** SELECT TIER VALUE **"
                      [ngModel]="tier"
                      (ngModelChange)="onTierChange($event)"
                      name="tier">
              </gtw-custom-select-local-system>
            </div>
          </div>
          <div class="form-group-row">
            <div class="form-label-col">
              <label>Table Name:</label>
            </div>
            <div class="form-value-col">
              <input type="text"
                     class="form-control input-sm"
                     name="tableName"
                     [ngModel]="tableName"
                     readonly
                     maxlength="40">
            </div>
          </div>
          <div class="form-group-row">
            <div class="form-label-col">
              <label>Column Name:</label>
            </div>
            <div class="form-value-col">
              <gtw-custom-select-local-system
                      [options]="column_name_data"
                      displayKey="COLUMN_NAME"
                      placeholder="** SELECT COLUMN NAME **"
                      [ngModel]="columnName"
                      (ngModelChange)="onColumnNameChange($event)"
                      [disabled]="!tierSelected"
                      name="columnName">
              </gtw-custom-select-local-system>
            </div>
          </div>
          <div class="form-group-row">
            <div class="form-label-col">
              <label>Column Value:</label>
            </div>
            <div class="form-value-col">
              <input type="text"
                     class="form-control input-sm"
                     name="columnValue"
                     [ngModel]="columnValue"
                     (ngModelChange)="columnValue=$event"
                     [disabled]="!tierSelected">
              @if (validationInfo) {
<span class="validation-hint">({{ validationInfo }})</span>
}
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
}
</div>

<div class="modal-footer" [hidden]="minimise">
  <div class="footer-row">
    @if (screen_key != '11308') {
<div class="footer-left">
      @if ((TRANS_TYPE_DATA?.values?.length ?? 0) > 0) {
<div class="transaction-drop">
        <gtw-df-select-multiple
          [filter]="TRANS_TYPE_DATA"
          (filterChange)="onTransTypeFilterChange()">
        </gtw-df-select-multiple>
      </div>
}
      @if (transDataLoaded && (TRANS_TYPE_DATA?.values?.length ?? 0) === 0) {
<span>No Transactions Found</span>
}
      <button class="delete-button delete-btn"
              type="button"
              [disabled]="(TRANS_TYPE_DATA?.selected?.length ?? 0) === 0 || deletingType !== null"
              (click)="deleteCodeCombi('DELETE_TRANS')">
        @if (deletingType === 'DELETE_TRANS') {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
        Delete Transaction(s)
      </button>
      <button class="delete-button delete-btn"
              type="button"
              [disabled]="deletingType !== null"
              (click)="deleteCodeCombi('DELETE_CC')">
        @if (deletingType === 'DELETE_CC') {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
        Delete Code Combination
      </button>
    </div>
}
    <div class="footer-right">
      @if (screen_key == '11308') {
<div class="footer-sync-actions">
        <div class="sync-type-dropdown">
          <gtw-custom-select-local-system
                  [options]="GT_SYNC_DATA"
                  displayKey="LABEL"
                  placeholder="Select"
                  [ngModel]="cng_type"
                  (ngModelChange)="onCngTypeChange($event)"
                  name="cng_type">
          </gtw-custom-select-local-system>
        </div>
        <button class="delete-button delete-btn"
                type="button"
                [disabled]="!cng_type || cleanupLoading"
                (click)="cleanupChangelog()">
          @if (cleanupLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
          Cleanup Change Log
        </button>
      </div>
}
      <button class="save-button"
              type="button"
              [disabled]="!columnNameSelected || saveLoading"
              (click)="save()">
        @if (saveLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
        Save
      </button>
      <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
    </div>
  </div>
</div>

<!-- Shared confirmation modal (cleanup change log / delete transaction / delete code combination) -->
@if (showConfirmDialog) {
<div class="confirmation-modal-overlay">
  <div class="confirmation-modal-dialog" (click)="$event.stopPropagation()">
    <gtw-confirmation-modal
      [config]="confirmModalConfig"
      [visible]="false"
      (confirmed)="onConfirm()"
      (cancelled)="onCancelConfirm()"
      (closed)="onCancelConfirm()">
    </gtw-confirmation-modal>
  </div>
</div>
}
